import { Spacing } from '@persona-id/design-tokens';
import { TrashIcon } from '@persona-id/design-tokens/icons';
import { ArrayFieldTemplateProps } from '@rjsf/utils';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ChildWrapper = styled.div`
  flex-grow: 1;
  margin-right: ${Spacing[2]};
`;

const ButtonContainer = styled.div`
  align-self: end;
`;

export function ArrayFieldTemplate({ items, onAddClick }: ArrayFieldTemplateProps) {
  return (
    <>
      {items.map((element) => (
        <ItemContainer key={element.index}>
          <ChildWrapper>{element.children}</ChildWrapper>
          <ButtonContainer>
            <Button
              variant='basic'
              width='icon'
              type='button'
              onClick={element.onDropIndexClick(element.index)}
              id={`rjsf-array-remove-${element.index + 1}`}
              aria-label={`Remove item ${element.index + 1}`}
            >
              <TrashIcon />
            </Button>
            <Spacer height={2} />
          </ButtonContainer>
        </ItemContainer>
      ))}
      <Button onClick={() => onAddClick()}>Add Item</Button>
    </>
  );
}
